export type PolarisMap = Record<
  DeployEnv,
  {
    namespace: string;
    service: string;
  }
>;

const polaris: PolarisMap = {
  test: {
    namespace: 'Test',
    service: 'FrontEnd.WebService',
  },
  ci: {
    namespace: 'Test',
    service: 'FrontEnd.WebService',
  },
  preRelease: {
    namespace: 'Production', // 七彩石数据使用线上配置
    service: 'FrontEnd.WebService',
  },
  production: {
    namespace: 'Production',
    service: 'FrontEnd.WebService',
  },
};

export default polaris;
